import { useState, useEffect } from 'react'
import { supabase } from '../supabase'

const cache = { data: null, ts: 0 }

export function useBrand() {
  const [brand, setBrand] = useState({
    name: 'PageConnect',
    website: 'pageconnect.io',
    email: 'help@pageconnect.io',
    whatsapp: '61435911737',
    facebook: 'https://facebook.com/pageconnect.io',
    tagline: 'Empowering F-commerce sellers worldwide',
    logo_url: '',
    logo_light_url: '',
    icon_url: '',
    icon_light_url: '',
    trial_days: '14',
    grace_period_days: '3',
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => { fetchBrand() }, [])

  const fetchBrand = async () => {
    if (cache.data && Date.now() - cache.ts < 30 * 1000) {
      setBrand(cache.data)
      setLoading(false)
      return
    }
    const { data } = await supabase.from('admin_settings').select('key, value')
    if (data) {
      const map = {}
      data.forEach(s => { map[s.key] = s.value })
      const b = {
        name: map.brand_name || 'PageConnect',
        website: map.brand_website || 'pageconnect.io',
        email: map.brand_email || 'help@pageconnect.io',
        whatsapp: map.brand_whatsapp || '61435911737',
        facebook: map.brand_facebook || 'https://facebook.com/pageconnect.io',
        tagline: map.brand_tagline || 'Empowering F-commerce sellers worldwide',
        logo_url: map.brand_logo_url || '',
        logo_light_url: map.brand_logo_light_url || '',
        icon_url: map.brand_icon_url || '',
        icon_light_url: map.brand_icon_light_url || '',
        trial_days: map.trial_days || '14',
        grace_period_days: map.grace_period_days || '3',
      }
      cache.data = b
      cache.ts = Date.now()
      setBrand(b)
    }
    setLoading(false)
  }

  return { brand, loading, refetch: fetchBrand }
}